import { IconMapCar16 } from '@cian/ui-kit-design-tokens/icons';
import { SpecialGeo } from '../../components/SpecialGeo';
import { useGeneralInfo } from '../../hooks';
import { useMemo } from 'react';
import { stopPropagation } from 'shared/utils/event';

export function HighwayContainer() {
  const { geo } = useGeneralInfo();

  const remoteness = useMemo(() => {
    if (!geo?.highway) {
      return;
    }

    const { highway, regionId } = geo;

    if (highway && highway.distance) {
      const distance = Math.round(Number(highway.distance));

      if ([1, 4593].includes(regionId)) {
        return `${distance} км от МКАД`;
      }
      if ([2, 4588].includes(regionId)) {
        return `${distance} км от КАД`;
      }
    }

    return undefined;
  }, [geo]);

  if (!geo?.highway) {
    return null;
  }

  return (
    <SpecialGeo
      label={`${geo.highway.name} шоссе`}
      icon={<IconMapCar16 color="icon-secondary-default" />}
      remoteness={remoteness}
      onClick={stopPropagation}
    />
  );
}
